// Возврат после входа — только на путь внутри сервиса (FR-008в; contracts/ui.md, «/login»):
// начинается с «/», не с «//» и не с «/\» (браузер читает «\» как «/»), без управляющих знаков.
// На вход, на ссылку-приглашение и на ссылку входа (030: /enter/<токен>, FR-006) не возвращаем:
// токен не должен попасть в адрес страницы входа.

export function safeNext(next: unknown): string {
  if (typeof next !== 'string' || next.length === 0) return '/';
  if (!next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return '/';
  // eslint-disable-next-line no-control-regex -- ищем именно управляющие знаки
  if (/[\u0000-\u001f\u007f]/.test(next)) return '/';
  const path = next.split(/[?#]/, 1)[0] ?? '';
  if (path === '/login' || path.startsWith('/invite/') || path.startsWith('/enter/')) return '/';
  return next;
}
